import React from 'react';
import PropTypes from 'prop-types';

/**
 * Render the provided markup if it exists wrapped in a <div>..
 *
 * @param {String} markup - Provided markup content.
 * @param {String} label -  Content label.
 * @return {String} - Rendered markup.
 */
const CardItem = ({ markup, label }) => {
  if (!markup || !label) return null;

  return (
    <div className={`card-item card-item--${label}`}>
      <p dangerouslySetInnerHTML={{ __html: `${markup}` }} className="card-item_content" />
    </div>
  );
};

CardItem.defaultProps = {
  markup: null,
  label: '',
};

CardItem.propTypes = {
  markup: PropTypes.string,
  label: PropTypes.string,
};

export default CardItem;
